<template>
  <div class="main-content">
    <div id="filter-container" class="filters-area d-flex">
      <div class="me-2">
        <input
          type="text"
          class="form-control"
          :placeholder="$t('utils.table.name')"
          v-model="name"
          @keyup="search()"
        />
      </div>
      <div>
        <select
          class="form-control"
          v-model="role"
          @change="
            page = 1;
            items = [];
            getUsers();
          "
        >
          <option value="all">{{ $t("utils.select.all-roles") }}</option>
          <option value="user">{{ $t("utils.select.user") }}</option>
          <option value="space_owner">{{
            $t("utils.select.spaceowner")
          }}</option>
          <option value="superadmin">Superadmin</option>
        </select>
      </div>
    </div>

    <div class="mt-4">
      <b-table
        striped
        hover
        :items="items"
        :fields="fields"
        :busy="loading"
        @sort-changed="sort()"
      >
        <template #cell(name)="row">
          <router-link
            class="actions-link"
            :to="{ name: 'UserDetailPage', params: { id: row.item.id } }"
          >
            <span>{{ row.item.name }}</span>
          </router-link>
        </template>

        <template #cell(actions)="row">
          <span
            class="actions-link"
            v-if="!row.item.banned"
            @click="banUser(row.item.id)"
            >{{ $t("dashboard.superadmin.users-detail.ban-user") }}</span
          >
          <span class="actions-link" v-else @click="unbanUser(row.item.id)">{{
            $t("dashboard.superadmin.users-detail.unban-user")
          }}</span>
        </template>

        <template #table-busy>
          <div class="text-center text-secondary my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
      </b-table>
    </div>

    <div class="pagination d-flex align-items-center justify-content-end p-4">
      <button
        class="btn d-flex align-items-center"
        @click="changePage(false)"
        :disabled="page === 1 || loading"
      >
        <img
          src="@/assets/images/icons/arrow-select.svg"
          alt="Previous page"
          class="prev"
        />
      </button>
      <button
        class="btn d-flex align-items-center"
        @click="changePage(true)"
        :disabled="disableNextPage || loading"
      >
        <img
          src="@/assets/images/icons/arrow-select.svg"
          alt="Next page"
          class="next"
        />
      </button>
    </div>

    <MessageBanner
      :message="error"
      :type="'error'"
      :classes="['position-bottom-center']"
      v-if="error !== ''"
    />
  </div>
</template>

<script>
import UserService from "@/services/user";

export default {
  data() {
    return {
      fields: [
        {
          key: "name",
          sortable: false,
          label: this.$t("utils.table.name")
        },
        {
          key: "email",
          sortable: false
        },
        {
          key: "registration_date",
          sortable: false,
          label: this.$t("dashboard.superadmin.users.registration-date")
        },
        {
          key: "age",
          sortable: false,
          label: this.$t("utils.age")
        },
        {
          key: "status",
          sortable: false,
          label: this.$t("sidebar.actions.status-label")
        },
        {
          key: "actions",
          label: "",
          sortable: false
        }
      ],
      items: [],
      users: [],
      loading: false,
      page: 1,
      disableNextPage: false,
      name: null,
      role: "all",
      error: ""
    };
  },

  methods: {
    async getUsers() {
      this.loading = true;

      try {
        const filters = {
          name: this.name !== "" ? this.name : null,
          role: this.role !== "all" ? this.role : null
        };
        const { data } = await UserService.getUsers(filters, this.page);

        this.users = data.data;

        this.items = this.users.map(user => {
          return {
            id: user.id,
            name: user.name,
            email: user.email,
            registration_date: this.$moment(user.createdAt).format(
              "DD/MM/YYYY"
            ),
            age: user.age,
            status: user.banned ? "Banned" : "Active",
            banned: user.banned
          };
        });

        this.disableNextPage = this.items.length !== data.pagination.pagelen;
      } catch (error) {
        this.error = error.response.data.message;

        setTimeout(() => {
          this.error = "";
        }, 2500);
      } finally {
        this.loading = false;
      }
    },

    search: _.debounce(function() {
      this.page = 1;
      this.items = [];

      this.getUsers();
    }, 500),

    sort() {
      if (this.sortDirection === "asc") {
        this.sortDirection = "desc";
      } else {
        this.sortDirection = "asc";
      }

      this.page = 1;
      this.items = [];

      this.getUsers();
    },

    changePage(isNext) {
      isNext ? this.page++ : this.page--;

      this.getUsers();
    },

    async banUser(id) {
      this.loading = true;

      await UserService.banUser(id);

      this.page = 1;
      this.items = [];

      this.getUsers();
    },

    async unbanUser(id) {
      this.loading = true;

      await UserService.unbanUser(id);

      this.page = 1;
      this.items = [];

      this.getUsers();
    }
  },

  mounted() {
    this.$store.dispatch(
      "utils/setSectionName",
      this.$t("dashboard.superadmin.menu.users")
    );
    this.$store.dispatch("sidebar/setAction", null);

    this.getUsers();
  }
};
</script>

<style lang="scss">
@import "src/assets/scss/components/table";
@import "src/assets/scss/filters";

.actions-link {
  cursor: pointer;
  font-family: $mulish;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  letter-spacing: 0.3px;
  color: #7e4ee2;
  text-transform: uppercase;
  text-decoration: none;
}

.pagination {
  button {
    .prev {
      transform: rotate(90deg);
    }

    .next {
      transform: rotate(-90deg);
    }

    &:focus {
      box-shadow: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/superadmin/users/UsersPage.vue